module.exports = __webpack_public_path__ + "static/media/trompete.5f29539f.mp3";